module.exports = __webpack_public_path__ + "static/media/30_1.bc134f48.png";